import { render, staticRenderFns } from "./event-extra-modules-container.vue?vue&type=template&id=6262d1c9&scoped=true"
import script from "./event-extra-modules-container.vue?vue&type=script&lang=js"
export * from "./event-extra-modules-container.vue?vue&type=script&lang=js"
import style0 from "./event-extra-modules-container.vue?vue&type=style&index=0&id=6262d1c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6262d1c9",
  null
  
)

export default component.exports